export const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "20", value: 20 },
    { text: "50", value: 50 }
];

export const initialFilter = {
    filter: {
        partner: "",
        livestock: "",
        area: "",
    },
    pageNumber: 1,
    pageSize: 10,
    sortField: "created_at",
    sortOrder: "DESC"
};

export const initialValue = {
    thk_period_uuid: "",
    thk_livestock_uuid: "",
    thk_partner_uuid: "",
    thk_area_uuid: "",
    qty: 0,
    description: "",
    price: 0,
    is_active: true,
    thk_period: {
        uuid: "",
        name: ""
    },
    thk_livestock: {
        uuid: "",
        name: ""
    },
    thk_partner: {
        uuid: "",
        name: ""
    },
    thk_area: {
        uuid: "",
        name: ""
    },
}
